import { Injectable } from '@angular/core';
import { UiHttp } from '@shared/services/ui-http/ui-http.service';
import { Observable } from 'rxjs';
import { Locale } from '@app/interfaces/locale.interface';

@Injectable({
  providedIn: 'root'
})
export class AppService {
    constructor(
        private http: UiHttp,
      ) {
      }

    getAllLocales(cp: string): Observable<Locale[]> {
        return this.http.get('all-locales/', { cp });
      }
}